export default __webpack_public_path__ + "static/social_sharing-b1f7f101d3fa17002b63ab9993c5fd7d.jpg";